import { reactive } from 'vue';

export const criarEstabelecimentoCli = () => {
    return reactive({
        id: 0,
        idestabelecimento: 0,
        nmcliente: '',
        cpfcnpj: '',
        nmmunicipio: '',
        uf: '',
        ativo: 'S',
        idlogin: 0,
        idusuario: 0
    });
};